export default {"src":"/_next/static/media/profile-difficulties.ce0d9692.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};